import React, {Fragment} from 'react';

import AggregateShellComponent from "../../../../gd-modules/common/aggregate/aggregate-shell";

export default function AggregateNumber(options, params, props) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const value = isValid ? props.value : null;

    const decimalPlaces = params ? params.decimalPlaces : 0;
    const valueLabel = typeof value === 'number' ? value.toFixed(decimalPlaces) : parseFloat(value).toFixed(decimalPlaces);

    let noDataLabel;
    switch (props.aggregateFunction) {
        case gd.const.aggregate.type.SUM:
            noDataLabel = '0';
            break;
        default:
            noDataLabel = gd.const.aggregate.label[props.aggregateFunction];
            break;
    }

    return (
        <AggregateShellComponent options={options} noData={!isValid} hint={value} {...props}>
            {isValid &&
            <Fragment>
                <div className="aggregate-label">{gd.const.aggregate.label[props.aggregateFunction]}:</div>
                <div className="aggregate-value aggregate-number">{valueLabel}</div>
            </Fragment>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{noDataLabel}</div>}
        </AggregateShellComponent>
    )
}